import Report from "../../../report";
import {ViewType} from "../../../../../gd/const/views/view-type";
import {ReportConfig} from "../../../@types";
import ReportTasksSummaryByUser_Settings from "./settings";
import SavedView from "../../../../saved-view/saved-view";
import ApiView from "../../../../../gd/api/view";

export default class ReportTasksSummaryByUser extends Report<ReportTasksSummaryByUser_Settings> {

    static reportName: string = "Tasks summary by user"

    constructor(data: ReportConfig) {
        data.type = ViewType.REPORT_TASK_SUMMARY_BY_USER
        super(data);

        this.icon         = "isvg-summary-by-user"
        this.description  = "Provides an overview of tasks assigned to a specific user, helping to track their progress and performance."

        this.settings     = new ReportTasksSummaryByUser_Settings(data.settings)
    }

    static initFromSavedView(savedView: SavedView): ReportTasksSummaryByUser {
        return new ReportTasksSummaryByUser(savedView.toReportConfig())
    }

    //Xotel dobavit po vishe. No tut raznie settings. Instance budet otlichatsya
    async getView(){
        try{
            const response = await ApiView.getView(this.id).promise()

            this.savedView = SavedView.initFromJson(response)
            //Set settings from saved view.
            this.settings  = new ReportTasksSummaryByUser_Settings(this.savedView.data.settings)
        }
        catch(e){
            console.error(e)
        }
    }

    save(){
        console.log("Not implemented")
    }
}
